var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt10"},[_c('div',{staticClass:"tool_company video-body",class:_vm.property.video==''?'none_video':''},[(_vm.property.video)?_c('video',{staticClass:"video",attrs:{"src":_vm.property.video,"id":"videoPlay","poster":_vm.property.poster}},[_vm._v("您的浏览器不支持 video 视屏播放。")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }